module.exports = __webpack_public_path__ + "fonts/Inter-Thin.35b7cf4c.ttf";